// extracted by mini-css-extract-plugin
export default {"root":"avatarField_root__HKWBb"};